// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"6dd762c8","977":"4288e1ed"}[chunkId] + ".chunk.js";
};